import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function MicrophoneCheckPage() {
  // End
  const navigate = useNavigate();
  const [audioLink, setaudioLink] = useState("");

  const handleButtonClick = () => {
    navigate("/");
  };
  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch("/ptedata/ptemedia/001_1585917752.mp3");
        const data = await res.json(); // expecting { url: "https://..." }
        setaudioLink(data.url);
      } catch (err) {
        console.error("Failed to fetch audio URL", err);
      }
    };

    fetchSignedUrl();
  }, []);

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Microphone Check
        </h1>
        <p className="p-2">
          This is an opportunity to check that your microphone is working
          correctly
          <br></br>
          <span>
            1. Make sure your headset is on and the microphone is in the
            downward position near your mouth.
          </span>
          <br></br>
          <span>
            2. When you are ready, click on the Record button and say "Testing,
            testing, one, two, three" into the microphone
          </span>
          <br></br>
          <span>
            3.After you have spoken, cilck on the Stop button. Your recording is
            now complete
          </span>
          <br></br>
          <span>
            4. Now click on the Playback button. You should clearly hear
            yourself speaking{" "}
          </span>
          <br></br>
          <span>
            5. If you can not hear your voice clearly. please raise your hand to
            get the atteration of the Test Administrator{" "}
          </span>
        </p>
        <img
          className=" absolute  top-12 right-12"
          width="200px"
          src="/image/headphones.jpg"
        ></img>
        <AudioPlayer audioSrc={audioLink} />
        <ul className="p-6">
          <li className=" list-disc pl-4">
            During the test, you will not have Record, Playback, and Stop
            buttons. The voice recording will start automatically.{" "}
          </li>
        </ul>
      </div>
    </div>
  );
}
